export enum QuickActionName {
    MESSAGE = 'message',
    PASSWORD = 'password',
    CLIENT_REQUEST_VEHICLE = 'client-request-vehicle',
    PRIORITIZE_DISPATCH = 'prioritize-dispatch',
    PRIORITIZE_SIGNAL = 'prioritize-signal',
    FAULTY_ALARM = 'faulty-alarm',
    SEND_RO_MESSAGE = 'send-ro-message',
    SEND_SUPERVISOR_MESSAGE = 'send-supervisor-message',
    MEDICAL = 'medical',
    MEDICAL_EDIT= 'medicalEdit',
    FIRE = 'fire',
    FIRE_EDIT = 'fireEdit',
    LOAD_TEMPORARY_WORK_FLOW = 'load-temporary-workflow',
    RO_INSTRUCTIONS = 'ro-instruction',
    GET_ACCESS_CODE = 'get-access-code',
    GATE_ACCESS = 'gate-access',
    RESPONSE_INSTRUCTIONS = 'response-instructions',
    SHOTS_FIRED = 'shots-fired',
    SHOTS_FIRED_HUB = 'shots-fired-hub',
    QUICK_ADD_SERVICE_CALL = 'quick-add-service-call',
    SUPERVISOR_REQUEST = 'supervisor-request',
    THIRD_PARTY_RESPONSE = '3rd party response',

}
